<template>
  <div>
    <p class="text-h5 font-weight-bold pa-0 ma-0">{{ head }}</p>
    <v-breadcrumbs class="pa-0 ma-0" :items="items"
      ><template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>
<script>
import { concat } from 'lodash'
export default {
  components: {},
  props: { head: String, aditionalItems: { type: Array, default: () => [] } },
  computed: {
    items() {
      const output = this.$route.matched
        .map(item => {
          const title = item.meta && item.meta.title ? item.meta.title : ''
          if (!title) {
            return
          }
          const path = item.path ? item.path : '/'
          return {
            text: title,
            disabled: false,
            to: path
          }
        })
        .filter(Boolean)

      return concat(output, this.aditionalItems).map(i => ({ ...i, exact: true }))
    }
  }
}
</script>
<style></style>
